import React from "react";

const getPictureUrl = url => {
  let replacedWidth = (url && url.replace("[WIDTH]", "280")) || "";
  const newUrl =
    (replacedWidth && replacedWidth.replace("[HEIGHT]", "280")) || "";
  return newUrl;
};

const PopularListItem = ({ category, handleSelectCategory }) => {
  const url = getPictureUrl(category.picture.url);
  return (
    <li className="items">
      <a
        href="javascript:void(0)"
        onClick={() =>
          handleSelectCategory(
            category.name,
            category.resultType,
            category.restaurantAddressPostalCode,
            category.restaurantAddressSlugAdminWard,
            category.restaurantAddressSlugCityName,
            category.restaurantSlugName,
            true
          )
        }
      >
        <div className="img">
          <img src={url} />
        </div>
        <div className="name">
          <label>{category.name}</label>
        </div>
      </a>
    </li>
  );
};

export default PopularListItem;
